import style from './style';
const boxShadow = style({
  prop: 'boxShadow',
  themeKey: 'shadows'
});
export default boxShadow;


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/shadows.js
// module id = 819
// module chunks = 25